"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = ['Honda', 'Toyota', 'Hyundai', 'Ford', 'Chevrolet', 'Nissan', 'Kia', 'Volkswagen', 'Volvo', 'GMC', 'Subaru', 'Dodge', 'Acura', 'Audi', 'Cadillac', 'BMW', 'Buick', 'Chrysler', 'Fiat', 'Infiniti', 'Jaguar', 'Jeep', 'Plymouth', 'Land Rover', 'Lexus', 'Mazda', 'Mercedes-Benz', 'Mitsubishi', 'Ram', 'Saab', 'Subaru', 'Suzuki', 'Tesla', 'Oldsmobile', 'Harley Davidson', 'Kawaski', 'Lincoln', 'Yamaha'];
exports["default"] = _default;